import { render, staticRenderFns } from "./SkinChip.vue?vue&type=template&id=d1df827a&scoped=true&"
import script from "./SkinChip.vue?vue&type=script&lang=ts&"
export * from "./SkinChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1df827a",
  null
  
)

export default component.exports